import { Pipe, PipeTransform } from '@angular/core';
import { OdqDateTime } from '../model/odq-datetime.model';

@Pipe({
    name: 'filterByDate',
    pure: false,
    standalone: false
})
export class FilterByDatePipe implements PipeTransform {
  transform(items: { effectiveOn: OdqDateTime }[], maxDate: Date): any {
    if (!items || !maxDate) {
      return items;
    }
    return items.filter(item => item.effectiveOn.toLocalDate() <= maxDate);
  }
}